import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const CreateWallet = async (postData) => {
  // Harendra remove next line
  return;
    try {
  return await post<ApiResponse<[]>>('/wallet/fabric/create', postData).then((res)=> {
    if(res?.success===true) {

    }
    else {

    }

  })
}
catch(e){

}
};
